export default ({ taskId, submissionId }) => {
    window.events.emit('tasks__submissions:createTask', { taskId, submissionId });
};
